export const context = {
  select: {
    placeholder: "Choose an organization",
  },
  toaster: {
    contextUpdated: "The organization has been updated",
  },
};
